import React, { useState, useMemo, useLayoutEffect } from "react";
import moment from "moment";
import Table from "../../../components/tables/tableCols1";
// import { PaginationNoRoute } from "../../../components/pagination/paginationNoRoute";
import EmptyState from "../../../assets/images/icons/ShippersEmpty.svg";
// import UpdateServiceArea from "../../../components/modals/admin/shippers/updateServiceArea";
import AttachDeliveryMode from "../../../components/modals/admin/shippers/attachDeliveryMode";
import DetachDeliveryMode from "../../../components/modals/admin/shippers/detachDeliveryMode";

export default function DeliveryModes({ shipper }) {
  const [data, setData] = useState([]);
  const updateDeliveryModeRef = React.useRef(null);

  function createTableData(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((order) => {
        let show = {
          title: order?.title,
          description: order?.description || '--',
          date: moment(order?.created_at).format("MMM DD, YYYY"),
          orderData: order,
        };
        outputArray.push({ show });
        return true;
      });
      return outputArray;
    }
  }

  useLayoutEffect(() => {
    const allDeliveryModes = shipper?.delivery_modes || [];
    const dataSet = createTableData(allDeliveryModes);
    setData(dataSet);
  }, [shipper?.delivery_modes]);

  const openUpdateModal = (params) => {
    let data = params?.show?.orderData;
    updateDeliveryModeRef.current.open();
    updateDeliveryModeRef.current.getDeliveryMode(data);
  };

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        // First group columns
        columns: [
          {
            Header: "Title",
            accessor: "show.title",
          },
          {
            Header: "Description",
            accessor: "show.description",
          },
          {
            Header: "Date Created",
            accessor: "show.date",
          },
        ],
      },
    ],
    []
  );
  return (
    <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-8 mt-8">
      <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
        <h3 className="text-lg font-medium">Delivery Modes</h3>
        <AttachDeliveryMode shipper_id={shipper?.id} />
      </div>
      <div className="bg-white dark:bg-[#121212] rounded-md py-4 ">
        {data?.length > 0 ? (
          <Table
            columns={columns}
            data={data?.length > 0 ? data : []}
            className="w-full"
            onClick={openUpdateModal}
            rowClass="hover:shadow-md cursor-pointer"
          />
        ) : (
          <div className="py-20 text-center">
            <div className="flex justify-center">
              <img
                src={EmptyState}
                className="w-auto h-[160px]"
                alt="no data"
              />
            </div>
            <h3 className="mt-8 text-xl font-bold">Attach Delivery Mode</h3>
            <p className="mt-2 text-sm text-[#9CA3AF]">
              You have to attach a delivery mode to complete this setup.
            </p>
          </div>
        )}
      </div>
      {/* <UpdateServiceArea ref={updateDeliveryModeRef} visibility={false} /> */}
      <DetachDeliveryMode
        ref={updateDeliveryModeRef}
        visibility={false}
        shipper_id={shipper?.id}
      />
    </div>
  );
}
